import { Component, OnInit, OnDestroy } from "@angular/core";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { SalesforceMapperService } from "app/services/salesforce-mapper.service";

@Component({
  selector: "app-clients",
  templateUrl: "./clients.component.html",
  styleUrls: ["./clients.component.scss"],
})
export class ClientsComponent implements OnInit, OnDestroy {
  organizations: any[] = [];
  programs: any[] = [];
  CACHE_TTL = 20 * 60 * 1000;

  constructor(
    private _getSalesforceDataService: GetSalesforceDataService,
    private salesforceMapper: SalesforceMapperService
  ) {}

  private storageListener = (event: StorageEvent) => {
    if (
      event.key === "cachedOrganizationData" ||
      event.key === "cachedProgramsData"
    ) {
      this.loadDataFromCache();
    }
  };

  ngOnInit(): void {
    this.loadDataFromCache();
    window.addEventListener("storage", this.storageListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener("storage", this.storageListener);
  }

  loadDataFromCache(): void {
    const orgCache = localStorage.getItem("cachedOrganizationData");
    const progCache = localStorage.getItem("cachedProgramsData");

    let needFreshFetch = false;

    if (orgCache) {
      const parsed = JSON.parse(orgCache);
      if (Date.now() - parsed.timestamp > this.CACHE_TTL) {
        needFreshFetch = true;
      } else {
        this.organizations = parsed.data;
      }
    } else {
      needFreshFetch = true;
    }

    if (progCache) {
      const parsed = JSON.parse(progCache);
      if (Date.now() - parsed.timestamp > this.CACHE_TTL) {
        needFreshFetch = true;
      } else {
        this.programs = parsed.data;
      }
    } else {
      needFreshFetch = true;
    }
    if (needFreshFetch) {
      this.fetchFromSalesforce();
    }
  }

  private fetchFromSalesforce(): void {
    this._getSalesforceDataService.getDataFromSalesforce1().subscribe(
      (response) => {
        if (response.success) {
          const dataSet = JSON.parse(response.msg);
          const orgs = dataSet.data.lstOrganizations || [];
          const progs = dataSet.data.lstPrograms || [];

          this.organizations = this.salesforceMapper.mapOrganizations(orgs);
          this.programs = this.salesforceMapper.mapPrograms(progs);

          localStorage.setItem(
            "cachedOrganizationData",
            JSON.stringify({ timestamp: Date.now(), data: this.organizations })
          );
          localStorage.setItem(
            "cachedProgramsData",
            JSON.stringify({ timestamp: Date.now(), data: this.programs })
          );
        }
      },
      (error) => {
        console.error("❌ Salesforce API Error:", error);
      }
    );
  }
}
